import { z } from 'zod';

const CustomersClub = z.object({
  nationalCode: z.string().nullable(),
  customerFullName: z.string().nullable(),
  gained: z.number(),
  exactGained: z.number(),
  spent: z.number(),
  customScore: z.number(),
  score: z.number(),
  exactScore: z.number(),
  branchId: z.number(),
  branchName: z.string().nullable(),
  farabixoMonthly: z.number(),
  farabixoDaily: z.number(),
  level: z.number(),
  calcTime: z.string(),
  hasClub: z.boolean(),
  isLegal: z.boolean(),
  isBlackList: z.boolean(),
});

type CustomersClub = z.infer<typeof CustomersClub>;

export { CustomersClub };
